package co.maytes.standupbot.dashboard.features.standupslist

import co.maytes.standupbot.dashboard.components.motion.ViewPhase
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.standup.StandupDto
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

object StandupsListContract {
    sealed interface Status {
        data object Idle : Status
        data object Loading : Status
        data object Ready : Status
        data object Refreshing : Status
        data class Error(val error: ApiError) : Status
    }

    data class State(
        val workspaceId: String? = null,
        val status: Status = Status.Idle,
        val items: List<StandupDto> = emptyList(),
        val hasEntered: Boolean = false,
    ) : MVIState {
        val showsRows: Boolean get() = status == Status.Ready || status == Status.Refreshing
        val isEmpty: Boolean get() = showsRows && items.isEmpty()
        val phase: ViewPhase
            get() = when (status) {
                Status.Idle, Status.Loading -> ViewPhase.Loading
                is Status.Error -> ViewPhase.Error
                Status.Ready, Status.Refreshing -> if (isEmpty) ViewPhase.Empty else ViewPhase.Ready
            }
    }

    sealed interface Intent : MVIIntent {
        data class Load(val workspaceId: String) : Intent
        data object Retry : Intent
        data class OpenDetail(val standupId: String) : Intent
        data object Create : Intent
    }

    sealed interface Action : MVIAction {
        data class Navigate(val path: String) : Action
    }
}
